import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useSession } from "@/api/auth";

export function RequireSession({ children }: { children: ReactNode }) {
  const { data: session, isLoading } = useSession();
  const location = useLocation();

  if (isLoading) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="flex min-h-screen items-center justify-center text-sm text-muted-foreground"
      >
        Loading…
      </div>
    );
  }

  if (!session) {
    // Cognito is the only auth path now that #154 deleted the pilot
    // form. Per Rupert PR-328 r1 #11: preserve search + hash so a
    // deep link like ``/projects?filter=mine#section`` round-trips
    // through sign-in instead of silently dropping query state.
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/auth/cognito/sign-in" replace state={{ returnTo }} />;
  }

  return <>{children}</>;
}
